export default "__VITE_ASSET__CCB4z1Dy__"